module.exports = __webpack_public_path__ + "img/starRate.df8dfd49.svg";